<!--风险指数-->
<template>
  <div class="ri commonborder flex_row">
    <div id="ri_line1" class="echarts"></div>
  </div>

</template>

<script>
import api from '@/apis/SecurityManagement'

let echarts = require('echarts/lib/echarts')
export default {
  data() {
    return {}
  },
  computed:{
    //轴线颜色
    axisLineColor(){
      return this.$store.state.axisLineColor
    },
    //轴文字颜色
    axisLabelColor(){
      return this.$store.state.axisLabelColor
    },
    //网格线属性
    splitLineStyle(){
      return this.$store.state.splitLineStyle
    },
    //图例文字颜色
    legendTextColor(){
      return this.$store.state.legendTextColor
    }
  },
  methods: {
    ri_line1(data) {
      let ri_line1 = echarts.init(document.getElementById('ri_line1'))
      ri_line1.setOption({
        color: ['#ffea04'],
        tooltip: {
          trigger: 'axis',
          textStyle: { fontSize: this.$echartsFontSize },
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          axisLabel: {
            color: this.axisLabelColor,
            fontSize: this.$echartsFontSize,
            lineHeight: this.$echartsFontSize + 2,
          },
          axisLine: { lineStyle: { color: this.axisLineColor} },
          axisTick: { show: true ,lineStyle:{color:this.axisLineColor},alignWithLabel: true,},
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        },
        yAxis: {
          axisLabel: { color: this.axisLabelColor, fontSize: this.$echartsFontSize - 2 ,formatter: "{value}%",},
          axisLine: { lineStyle: { color:this.axisLineColor } },
          splitNumber: 3,
          splitLine: { lineStyle: this.splitLineStyle },
          max:200
        },
        grid: { left: '2%',right:'11%',top:'12%',bottom:'2%',containLabel: true},
        series: [
          {
            name: '风险指数',
            type: 'line',
            data: data, // [120, 110, 160, 80, 120, 160, 120, 110, 70, 90, 100, 70],
            symbolSize: 10,
            symbol: 'circle',
            markLine: {
              data: [
                {
                  type: 'average',
                  symbol: 'none',
                  yAxis: '150',
                  label: {
                    position: 'end',
                    formatter: '高风险',
                    fontSize: this.$echartsFontSize,
                  },
                  lineStyle: { color: '#ff5f8c' },
                },
                {
                  type: 'average',
                  symbol: 'none',
                  yAxis: '100',
                  label: {
                    position: 'end',
                    formatter: '中风险',
                    fontSize: this.$echartsFontSize,
                  },
                  lineStyle: { color: '#fff45c' },
                },
                {
                  type: 'average',
                  symbol: 'none',
                  yAxis: '50',
                  label: {
                    position: 'end',
                    formatter: '低风险',
                    fontSize: this.$echartsFontSize,
                  },
                  lineStyle: { color: '#24ffb1' },
                },
              ],
            },
          },
        ],
      })
      this.$common.moveEcharts(12,ri_line1);
    },
  },
  mounted() {
    //风险指数
    api
      .risk({
        params: {
          limit: 100,
          page: 1,
        },
      })
      .then((res) => {
        if (res.code === 10000) {
          if (res.data.list.length) {
            let data = res.data.list[0]

            this.$nextTick(() => {
              this.ri_line1([
                data.oneData,
                data.twoData,
                data.threeData,
                data.fourData,
                data.fiveData,
                data.sixData,
                data.sevenData,
                data.eightData,
                data.nineData,
                data.tenData,
                data.elevenData,
                data.twelveData,
              ])
            })
          } else {
            this.$nextTick(() => {
              this.ri_line1([
                120, 110, 160, 80, 120, 160, 120, 110, 70, 90, 100, 70,
              ])
            })
          }
        } else {
          this.$message.error(res.message)
        }
      })
  },
}
</script>

<style lang="less" scoped>
.ri {
  #ri_line1 {
    height: 100%;
    width: 100%;
  }
}
</style>